import { Badge } from "@chakra-ui/react";
import { LINE_ROLES, LINE_TYPES } from "./placingUtils";

/** "Lead" (dark blue) or "Follower" (gray). */
export const RoleBadge = ({ role, ...props }) => {
  const r = LINE_ROLES[role];
  if (!r) return null;
  return <Badge colorScheme={r.colour} variant={r.variant} {...props}>{r.label}</Badge>;
};

/** "Conditional" (amber) or "Unconditional" (green). */
export const LineTypeBadge = ({ lineType, ...props }) => {
  const t = LINE_TYPES[lineType];
  if (!t) return null;
  return <Badge colorScheme={t.colour} {...props}>{t.label}</Badge>;
};

/** Shown when a line must stand (it won't be signed down). */
export const StandsBadge = (props) => (
  <Badge colorScheme="purple" variant="outline" {...props}>stands</Badge>
);
